import { proxy } from 'valtio';
export const useSymbolStore = proxy({ currentSymbol: 'TX-1' });
